export default from './comment-footer';



// WEBPACK FOOTER //
// ./app/components/comment-footer/index.js